import React from 'react'
import { Stack, Typography } from '@mui/material'
import { Video, type VideoData } from '@media-components'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { StylesClassNames } from './styles'
import type { CardData } from '../DefaultCard'

export type VideoCardData = Partial<CardData> & {
  videoData?: VideoData
}
type Props = VideoCardData & {
  csx?: CustomStyles<StylesClassNames>
}

export function VideoCard({ title, description, videoData, csx }: Props) {
  const styles = getStyles(defaultStyles, csx)
  return (
    <Stack spacing={3} style={{ flex: 1 }}>
      {videoData && (
        <Video
          {...videoData}
          csx={{
            wrapper: styles('wrapper').sx,
          }}
        />
      )}
      <Stack spacing={1}>
        {title && <Typography variant="body1.600">{title}</Typography>}
        {description && (
          <Typography variant="body3.500" color="text.secondary">
            {description}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
